<div *ngIf="isVisible" class="relative z-30" aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <!-- Background backdrop -->
  <div class="fixed inset-0 bg-secondary-900 bg-opacity-50 backdrop-blur-sm transition-opacity"></div>

  <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
    <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
      <!-- Modal panel -->
      <div class="relative transform overflow-hidden rounded-2xl bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">

        <form [formGroup]="dealForm" (ngSubmit)="saveDeal()">

          <!-- Close button -->
          <div class="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
            <button type="button" (click)="closeModal()" class="rounded-md bg-white text-gray-400 hover:opacity-90 focus:outline-none">
              <span class="sr-only">Close</span>
              <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          <div class="px-4 py-4 lg:px-6 lg:py-6">
            <h3 class="text-2xl font-semibold text-gray-900 mb-6" id="modal-title">
              {{ mode === 'edit' ? 'Edit deal' : 'Create new deal' }}
            </h3>

            <div class="space-y-4">
              <!-- Deal Name -->
              <fieldset [disabled]="loading">
                <label for="dealName" class="block text-sm font-medium leading-6 text-gray-900">
                  Deal Name<span class="text-red-500 ml-1">*</span>
                </label>
                <div class="mt-2">
                  <input
                    type="text"
                    id="dealName"
                    name="dealName"
                    formControlName="dealName"
                    placeholder="Enter deal name"
                    class="block w-full rounded-md border-0 py-1.5 pl-3 pr-3 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm/6"
                  />
                </div>
                <div class="pt-1" *ngIf="dealForm.get('dealName')?.touched && dealForm.get('dealName')?.invalid">
                  <div class="text-xs text-red-500" *ngIf="dealForm.get('dealName')?.errors?.['required']">
                    Deal Name is required.
                  </div>
                </div>
              </fieldset>

              <!-- Deal Stage -->
              <fieldset [disabled]="loading">
                <label for="dealStage" class="block text-sm font-medium leading-6 text-gray-900">
                  Deal Stage<span class="text-red-500 ml-1">*</span>
                </label>
                <div class="mt-2">
                  <select
                    id="dealStage"
                    name="dealStage"
                    formControlName="dealStage"
                    class="block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-primary sm:text-sm/6"
                  >
                    <option value="">Select Deal stage</option>
                    <option *ngFor="let stage of dealStages" [value]="stage">
                      {{ stage | titlecase }}
                    </option>
                  </select>
                </div>
                <div class="pt-1" *ngIf="dealForm.get('dealStage')?.touched && dealForm.get('dealStage')?.invalid">
                  <div class="text-xs text-red-500" *ngIf="dealForm.get('dealStage')?.errors?.['required']">
                    Deal Stage is required.
                  </div>
                </div>
              </fieldset>

              <!-- Amount -->
              <fieldset [disabled]="loading">
                <label for="amount" class="block text-sm font-medium leading-6 text-gray-900">
                  Amount
                </label>
                <div class="mt-2">
                  <input
                    type="number"
                    id="amount"
                    name="amount"
                    formControlName="amount"
                    placeholder="Enter amount"
                    min="0"
                    class="block w-full rounded-md border-0 py-1.5 pl-3 pr-3 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm/6"
                  />
                </div>
              </fieldset>

              <!-- Select Contact -->
              <fieldset [disabled]="loading">
                <label for="contactId" class="block text-sm font-medium leading-6 text-gray-900">
                  Select Contact<span class="text-red-500 ml-1">*</span>
                </label>
                <div class="mt-2 flex items-center gap-2">
                  <select
                    id="contactId"
                    name="contactId"
                    formControlName="contactId"
                    class="block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-primary sm:text-sm/6"
                  >
                    <option value="">Select Contact</option>
                    <option *ngFor="let contact of filteredContacts" [value]="contact.id">
                      {{ contact.name }} {{ contact.surname }}
                    </option>
                  </select>
                  <button
                    *ngIf="dealForm.get('contactId')?.value"
                    type="button"
                    (click)="clearContact()"
                    title="Clear contact"
                    aria-label="Clear contact"
                    class="flex-shrink-0 rounded-full p-1.5 text-gray-400 hover:bg-gray-100 hover:text-red-500 focus:outline-none focus:ring-2 focus:ring-primary">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-4">
                      <path d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                    </svg>
                  </button>
                </div>

                <!-- No contacts available message (when filtered by company) -->
                <div class="pt-1" *ngIf="dealForm.get('companyId')?.value && filteredContacts.length === 0">
                  <div class="text-xs text-red-500">
                    This company has no associated contacts
                  </div>
                </div>

                <div class="pt-1" *ngIf="dealForm.get('contactId')?.touched && dealForm.get('contactId')?.invalid">
                  <div class="text-xs text-red-500" *ngIf="dealForm.get('contactId')?.errors?.['required']">
                    Contact is required.
                  </div>
                </div>
              </fieldset>

              <!-- Select Company -->
              <fieldset [disabled]="loading">
                <label for="companyId" class="block text-sm font-medium leading-6 text-gray-900">
                  Select Company<span class="text-red-500 ml-1">*</span>
                </label>
                <div class="mt-2 flex items-center gap-2">
                  <select
                    id="companyId"
                    name="companyId"
                    formControlName="companyId"
                    class="block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm/6"
                  >
                    <option value="">Select Company</option>
                    <option *ngFor="let company of filteredCompanies" [value]="company.id">
                      {{ company.name }}
                    </option>
                  </select>
                  <button
                    *ngIf="dealForm.get('companyId')?.value"
                    type="button"
                    (click)="clearCompany()"
                    title="Clear company"
                    aria-label="Clear company"
                    class="flex-shrink-0 rounded-full p-1.5 text-gray-400 hover:bg-gray-100 hover:text-red-500 focus:outline-none focus:ring-2 focus:ring-primary">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-4">
                      <path d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                    </svg>
                  </button>
                </div>

                <!-- No companies available message (when filtered by contact) -->
                <div class="pt-1" *ngIf="dealForm.get('contactId')?.value && filteredCompanies.length === 0">
                  <div class="text-xs text-red-500">
                    This contact has no associated companies
                  </div>
                </div>

                <!-- Validation error -->
                <div class="pt-1" *ngIf="dealForm.get('companyId')?.touched && dealForm.get('companyId')?.invalid">
                  <div class="text-xs text-red-500" *ngIf="dealForm.get('companyId')?.errors?.['required']">
                    Company is required.
                  </div>
                </div>
              </fieldset>

              <!-- Close Date -->
              <fieldset [disabled]="loading">
                <label id="closeDateLabel" class="block text-sm font-medium leading-6 text-gray-900">
                  Close Date<span class="text-red-500 ml-1">*</span>
                </label>
                <div class="mt-2 relative">
                  <input
                    type="text"
                    id="closeDate"
                    name="closeDate"
                    formControlName="closeDate"
                    [matDatepicker]="closeDatePicker"
                    [min]="minCloseDate"
                    (click)="closeDatePicker.open()"
                    aria-labelledby="closeDateLabel"
                    readonly
                    placeholder="Choose a date"
                    class="block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm/6 cursor-pointer bg-white"
                  />
                  <button
                    type="button"
                    (click)="closeDatePicker.open()"
                    aria-label="Open calendar"
                    class="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-primary focus:outline-none">
                    <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                      <path fill-rule="evenodd" d="M5.75 2a.75.75 0 01.75.75V4h7V2.75a.75.75 0 011.5 0V4h.25A2.75 2.75 0 0118 6.75v8.5A2.75 2.75 0 0115.25 18H4.75A2.75 2.75 0 012 15.25v-8.5A2.75 2.75 0 014.75 4H5V2.75A.75.75 0 015.75 2zm-1 5.5c-.69 0-1.25.56-1.25 1.25v6.5c0 .69.56 1.25 1.25 1.25h10.5c.69 0 1.25-.56 1.25-1.25v-6.5c0-.69-.56-1.25-1.25-1.25H4.75z" clip-rule="evenodd" />
                    </svg>
                  </button>
                  <mat-datepicker #closeDatePicker="matDatepicker" panelClass="deal-datepicker" [touchUi]="isMobile"></mat-datepicker>
                </div>
                <div class="pt-1" *ngIf="dealForm.get('closeDate')?.touched && dealForm.get('closeDate')?.invalid">
                  <div class="text-xs text-red-500" *ngIf="dealForm.get('closeDate')?.errors?.['required']">
                    Close Date is required.
                  </div>
                  <div class="text-xs text-red-500" *ngIf="dealForm.get('closeDate')?.errors?.['matDatepickerMin']">
                    Close Date cannot be in the past.
                  </div>
                </div>
              </fieldset>
            </div>
          </div>

          <!-- Action buttons -->
          <div class="px-4 sm:px-6 pb-6 grid grid-cols-2 gap-4">
            <button
              type="button"
              (click)="closeModal()"
              [disabled]="loading"
              class="w-full rounded-md px-4 py-3 text-sm font-medium text-gray-700 bg-white border border-gray-300 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary disabled:opacity-50 disabled:cursor-not-allowed">
              Cancel
            </button>
            <button
              type="submit"
              [disabled]="loading || dealForm.invalid"
              class="w-full rounded-md px-4 py-3 text-sm font-medium text-white bg-primary hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary disabled:opacity-50 disabled:cursor-not-allowed">
              <span *ngIf="!loading">{{ mode === 'edit' ? 'Update Deal' : 'Save Deal' }}</span>
              <span *ngIf="loading" class="flex items-center justify-center">
                <svg class="animate-spin h-5 w-5 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Saving...
              </span>
            </button>
          </div>

        </form>

      </div>
    </div>
  </div>
</div>
